import React, { FC } from "react";
import { FeeRiskProfile } from "~/design-system";
import { useMutation } from "~/hooks";
import { UPDATE_MATTER } from "../graphql/mutation";

import styles from "./fee-risk-profile-tab-container.module.css";

const { ["container"]: containerClassName, ["body-section"]: bodySectionClassName } = styles;

type FeeRiskProfileContainerProps = {
  matterId: number;
  currencySymbol: string;
  legalFees: number | { lower: number; upper: number };
  feeRiskLower: number | null;
  feeRiskUpper: number | null;
  fixedFeeAlternative: number | null;
  cappedFeeAlternative: number | null;
  onFeeRiskLowerChange: (fee: number) => void;
  onFeeRiskUpperChange: (fee: number) => void;
  onFixedFeeAlternativeChange: (fee: number) => void;
  onCappedFeeAlternativeChange: (fee: number | null) => void;
  showCappedFee: boolean;
};

export const FeeRiskProfileTabContainer: FC<FeeRiskProfileContainerProps> = ({
  matterId,
  currencySymbol,
  legalFees,
  feeRiskLower,
  feeRiskUpper,
  fixedFeeAlternative,
  cappedFeeAlternative,
  onFeeRiskLowerChange,
  onFeeRiskUpperChange,
  onFixedFeeAlternativeChange,
  onCappedFeeAlternativeChange,
  showCappedFee,
}) => {
  const [updateMatter] = useMutation(UPDATE_MATTER);

  return (
    <div className={containerClassName}>
      <div className={bodySectionClassName}>
        <FeeRiskProfile
          currencySymbol={currencySymbol}
          legalFees={legalFees}
          feeRiskLower={feeRiskLower}
          feeRiskUpper={feeRiskUpper}
          fixedFeeAlternative={fixedFeeAlternative}
          cappedFeeAlternative={cappedFeeAlternative}
          onFeeRiskLowerChange={onFeeRiskLowerChange}
          onFeeRiskUpperChange={onFeeRiskUpperChange}
          onFixedFeeAlternativeChange={onFixedFeeAlternativeChange}
          onCappedFeeAlternativeChange={onCappedFeeAlternativeChange}
          showCappedFee={showCappedFee}
          onShowCappedFeeChange={(showCappedFee) => {
            updateMatter({
              variables: {
                id: matterId,
                data: {
                  feeRiskCappedFeeInclude: { set: showCappedFee },
                },
              },
            });
          }}
        />
      </div>
    </div>
  );
};
